<template>
  <v-card
    :ripple="false"
    min-height="245px"
    flat
    :to="$func.generateNewLink(event)"
    :hover="!$vuetify.breakpoint.mobile"
    tile

  >
    <v-container class="pl-0 pb-0 pt-0">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" sm="5" class="pa-0">
          <v-img
            height="245px"
            
            :src="$store.state.imagePath + 'news-and-events/' + event.img"
          >
          </v-img
        ></v-col>
        <v-col cols="12" sm="7">
          <v-card flat tile>
            <v-card-title class="btn-cap">{{ event.title }}</v-card-title>
            <v-card-subtitle class="primary--text"
              >By {{ event.author }} |{{
                generateDate(event.date)
              }}</v-card-subtitle
            >
            <v-card-text class="pb-0 text-trunc-3">{{
              event.content
            }}</v-card-text>
            <v-card-actions>
              <v-btn class="text-capitalize" plain text depressed tile color="primary">
                read more</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container></v-card
  >
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
  },
  methods: {
    generateDate(date) {
      const d = new Date(date);
      return d.toDateString() + " " + d.toLocaleTimeString();
    },
  },
};
</script>
<style>
</style>